import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';
import { Button, customScrollStyles, InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { greetingCardAnalytics } from 'APP/packages/analytics/analytics';

import styles from './GreetingCard.styles.m.css';
import { GreetingCardBanner } from './GreetingCardBanner/GreetingCardBanner';

interface IGreetingCardQueryParams {
  deepLink: boolean;
  type: string;
  userDeepLink: string;
  caption: string;
  username: string;
  imageUrl: string;
}

export const GreetingCard: FC = observer(() => {
  const { t } = useTranslation();
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const queryParams = Object.fromEntries(
    urlSearchParams.entries()
  ) as unknown as IGreetingCardQueryParams;

  useEffect(() => {
    greetingCardAnalytics.trackOpenCardPage();
  }, []);

  if (!(queryParams.imageUrl && queryParams.userDeepLink)) {
    return (
      <>
        <GreetingCardBanner />
        <InfoBlock
          className={styles.notFound}
          title={t('bot_cards_something_wrong')}
          descriptions={[t('bot_cards_card_unavailable')]}
          type={InfoBlockTypes.Page}
          image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)}
        />
      </>
    );
  }

  return (
    <div className={classNames(styles.container, customScrollStyles.container)}>
      <GreetingCardBanner />
      <div className={styles.innerContainer}>
        <div className={styles.card}>
          <img
            className={styles.cardImg}
            src={queryParams.imageUrl}
            alt="Greeting card"
          />
          <p className={styles.caption}>{t('bot_cards_sender', { 0: queryParams.username })}</p>
          <Button
            onClick={(): void => {
              greetingCardAnalytics.trackTapReply();
              window.open(queryParams.userDeepLink, '_blank');
            }}
            className={styles.replyBtn}
            theme="primary"
            size="20"
          >
            {t('message_reply')}
          </Button>
        </div>
      </div>
    </div>
  );
});
